import {
  tryCatch,
  pipe,
  over,
  toUpper,
  join,
  replace,
  lensIndex,
  map,
  toLower,
  split,
  ifElse,
  isEmpty,
  identity,
} from 'ramda'

const tryTo = fn => tryCatch(fn, () => '')

export const capitalize = tryTo(pipe(over(lensIndex(0), toUpper), join('')))

// ------- Parsers ------- //

export const parseFromSnakeCase = replace(/_/g, ' ')

export const parseFromCamelCase = replace(/([^A-Z])([A-Z])/g, '$1 $2')

export const parseFromSentenceCase = pipe(map(toLower), join(''))

export const parseFromContantCase = pipe(toLower, split('_'), join(' '))

export const toSnakeCase = pipe(replace(/\s/g, '_'))

export const toUpperCamelCase = pipe(
  split(' '),
  map(capitalize),
  join(''),
  // for some reason this isn't working, but it should
  // does no harm, so leaving it here to keep trying
  replace(/'+/g, ''),
)

export const toSentenceCase = tryTo(
  pipe(
    // lower case everything
    map(toLower),
    // make the first character uppercase
    ifElse(isEmpty, identity, pipe(over(lensIndex(0), toUpper), join(''))),
    // remove duplicate spaces
    replace(/[\s]+/g, ' '),
  ),
)

export const toConstantCase = pipe(toUpper, replace(/\s/g, '_'))

// ------- Utilities ------- //

export const snakeCaseToSentenceCase = tryTo(
  pipe(parseFromSnakeCase, toSentenceCase),
)

export const camelCaseToSentenceCase = tryTo(
  pipe(parseFromCamelCase, toSentenceCase),
)

export const constantToSentenceCase = tryTo(
  pipe(parseFromContantCase, toSentenceCase),
)

export const anyToSentenceCase = tryTo(
  pipe(parseFromCamelCase, parseFromSnakeCase, toSentenceCase),
)
